import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { fetchOrganization } from 'redux/modules/organization';
import { clearUpcomingContentTemplate, getUpcomingPosts } from 'redux/modules/reportUpcomingContent';
import { clearOrgSearchResults } from 'redux/modules/auth';
import { getFBAdPreviewSrc } from 'redux/modules/adBuilder';
import { clearFBChecklistTemplate, getPageFields, prePopulateChecklist, updateFBChecklist } from 'redux/modules/reportFacebookChecklist';
import { clearTemplate, getPageStats, getRecentPosts, getPageInsights, getAds } from 'redux/modules/reportSocialMediaSummary';
import { updateNonAsyncField, clearSettings, loadReport, getWhitelabelInfo, simpleGetReport, updateSelectedClient, updateField } from 'redux/modules/reportBuilder';
import { getReports } from 'redux/modules/reporting';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import { LeftNavLayout } from 'containers';
import { EmptyState, PageHeader, Spinner } from 'components';
import { Builder, Preview, Settings } from 'containers/ReportBuilder';
import * as styles from './ReportBuilder.scss';
var ReportBuilder = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    savingReport: state.reportBuilder.savingReport,
    selectedClient: state.reportBuilder.selectedClient,
    selectedReportType: state.reportBuilder.selectedReportType,
    reportTypes: state.reportBuilder.reportTypes,
    startDate: state.reportBuilder.startDate,
    endDate: state.reportBuilder.endDate,
    upcomingContentTemplate: state.reportUpcomingContent,
    socialMediaSummaryTemplate: state.reportSocialMediaSummary,
    facebookChecklistTemplate: state.reportFacebookChecklist,
    loadingReport: state.reportBuilder.loadingReport,
    reportsById: state.reportBuilder.reportsById && state.reportBuilder.reportsById[orgId] ? state.reportBuilder.reportsById[orgId] : null
  };
}, {
  clearOrgSearchResults: clearOrgSearchResults,
  clearSettings: clearSettings,
  clearFBChecklistTemplate: clearFBChecklistTemplate,
  clearUpcomingContentTemplate: clearUpcomingContentTemplate,
  fetchOrganization: fetchOrganization,
  getFBAdPreviewSrc: getFBAdPreviewSrc,
  getPageFields: getPageFields,
  updateFBChecklist: updateFBChecklist,
  getUpcomingPosts: getUpcomingPosts,
  getPageStats: getPageStats,
  getRecentPosts: getRecentPosts,
  getPageInsights: getPageInsights,
  getAds: getAds,
  prePopulateChecklist: prePopulateChecklist,
  updateNonAsyncField: updateNonAsyncField,
  updateField: updateField,
  clearTemplate: clearTemplate,
  getReports: getReports,
  loadReport: loadReport,
  getWhitelabelInfo: getWhitelabelInfo,
  simpleGetReport: simpleGetReport,
  updateSelectedClient: updateSelectedClient
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ReportBuilder, _Component);

  var _super = _createSuper(ReportBuilder);

  function ReportBuilder(props) {
    var _this;

    _classCallCheck(this, ReportBuilder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearAll", function () {
      _this.props.clearSettings();

      _this.props.clearFBChecklistTemplate();

      _this.props.clearUpcomingContentTemplate();

      _this.props.clearTemplate();
    });

    _defineProperty(_assertThisInitialized(_this), "getReportStuff", function (orgId, reportType) {
      if (!_this.props.selectedClient) {
        return false;
      }

      var SocialAccountId = _this.props.selectedClient.SocialAccountId;

      if (reportType === 'upcomingContent') {
        _this.props.getUpcomingPosts(orgId, _this.props.startDate, _this.props.endDate);
      } else if (reportType === 'socialMediaSummary') {
        var fields = 'fan_count';

        _this.props.getPageFields(orgId, SocialAccountId, fields);

        _this.props.getPageStats(orgId, _this.props.startDate.format(), _this.props.endDate.format())["catch"](function (error) {
          _this.setState({
            snackbarOpen: true,
            snackbarMessage: 'Unable to get overview for this date range.'
          });
        });

        _this.props.getPageInsights(orgId, _this.props.startDate.format(), _this.props.endDate.format())["catch"](function (error) {
          _this.setState({
            snackbarOpen: true,
            snackbarMessage: 'Unable to get audience insights for this date range.'
          });
        });

        _this.props.getRecentPosts(orgId, SocialAccountId, _this.props.startDate.format(), _this.props.endDate.format()).then(function (res) {
          var post = res.data.posts[0]; // only get the preview for the first post

          _this.props.getFBAdPreviewSrc(orgId, SocialAccountId, 'DESKTOP_FEED_STANDARD', {
            postId: post.id
          });
        })["catch"](function (error) {
          _this.setState({
            snackbarOpen: true,
            snackbarMessage: 'Unable to find posts for this date range.'
          });
        });

        _this.props.getAds(orgId, _this.props.startDate.format(), _this.props.endDate.format())["catch"](function (error) {
          _this.setState({
            snackbarOpen: true,
            snackbarMessage: 'Unable to find ads for this date range.'
          });
        }).then(function (res) {
          // only get previews for non-promoted post ads
          res.data.forEach(function (ad, index) {
            if (ad.name.slice(0, 4) !== 'act_') {
              _this.props.getFBAdPreviewSrc(orgId, SocialAccountId, 'DESKTOP_FEED_STANDARD', {
                adId: ad.id
              });
            }
          });
        });
      } else if (reportType === 'facebookChecklist') {
        var _fields = 'page_about_story,price_range,rating_count,about,category,connected_instagram_account,instagram_business_account,instagram_accounts,page_backed_instagram_accounts,settings,cover,emails,founded,hours,messenger_ads_default_icebreakers,link,name,parking,phone,picture,products,ratings,single_line_address,username,unread_message_count,verification_status,website';

        _this.props.getPageFields(orgId, SocialAccountId, _fields); // need this routine to get the previous checklist report score


        _this.props.getReports(orgId).then(function (res) {
          var checklistReports = res.data.filter(function (report) {
            return report.reportType === 'facebookChecklist' && !report.isArchived;
          });
          var lastReport = checklistReports.length ? checklistReports.sort(function (a, b) {
            return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
          })[0] : null;

          if (lastReport) {
            _this.props.updateFBChecklist('lastReportId', lastReport.id);

            _this.props.simpleGetReport(orgId, lastReport.id).then(function (res) {
              var previousScore = res.data && res.data.details && res.data.details.sections && !!res.data.details.sections.length ? res.data.details.sections.map(function (section) {
                return section.score;
              }).reduce(function (acc, currentValue) {
                return acc + currentValue;
              }) : 0;

              _this.props.updateFBChecklist('lastReportScore', Math.round(previousScore));

              _this.props.updateFBChecklist('lastReportDate', moment(lastReport.updatedAt).format('MM/DD/YYYY'));

              if (res.data && res.data.details && res.data.details.sections && !!res.data.details.sections.length) {
                _this.props.prePopulateChecklist(res.data.details.sections);
              }
            });
          }
        });
      }

      _this.props.clearOrgSearchResults();
    });

    _defineProperty(_assertThisInitialized(_this), "loadReport", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orgId, reportId) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.loadReport(orgId, reportId);

              case 2:
                res = _context.sent;

                if (!res.data.S3File) {
                  _context.next = 6;
                  break;
                }

                // this shouldn't be needed, but in dev, the Download Report button wasn't always showing up even when it should
                _this.forceUpdate();

                return _context.abrupt("return", true);

              case 6:
                // prevent Spinner from flashing every time loadReport() happens
                _this.setState({
                  loadedReportOnce: true
                });

                setTimeout(function () {
                  _this.loadReport(orgId, reportId);
                }, 2000);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.state = {
      snackbarOpen: false,
      loadedReportOnce: false
    };
    return _this;
  }

  _createClass(ReportBuilder, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var orgData, org, fbPage, SocialAccountId, FacebookAdAccountId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.props.params.reportId) {
                  // params.orgId only exists on routes for editing or viewing an existing report
                  this.loadReport(this.props.params.orgId, this.props.params.reportId);
                } // START new report stuff
                // params.organizationId only happens in a route creating a new report, not viewing or editing an existing report


                if (!this.props.params.organizationId) {
                  _context2.next = 16;
                  break;
                }

                if (!this.props.params.reportType) {
                  _context2.next = 16;
                  break;
                }

                if (this.props.params.reportType === 'socialMediaSummary') {
                  this.props.updateNonAsyncField('reportTitle', "".concat(moment().subtract(1, 'month').format('MMMM YYYY'), " Social Media Summary"));
                } else if (this.props.params.reportType === 'facebookChecklist') {
                  this.props.updateNonAsyncField('reportTitle', "Facebook Facelift Report - ".concat(moment().format('MM/DD/YYYY')));
                } else {
                  console.log('this should be helping upcomingContent report');
                  this.props.updateNonAsyncField('reportTitle', 'Upcoming Content Report');
                  this.props.updateField('startDate', moment());
                  this.props.updateField('endDate', moment().add(2, 'weeks'));
                } // only do this routine on mount


                _context2.next = 6;
                return this.props.fetchOrganization(this.props.params.organizationId);

              case 6:
                orgData = _context2.sent;
                org = orgData.data;
                this.props.getWhitelabelInfo(org.parentOrganizationId ? org.parentOrganizationId : this.props.params.organizationId);
                fbPage = org.SocialAccounts && org.SocialAccounts.length ? org.SocialAccounts.find(function (sa) {
                  return sa.platform === 'Facebook page';
                }) : null;

                if (fbPage) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", false);

              case 12:
                SocialAccountId = parseInt(fbPage.id, 10);
                FacebookAdAccountId = parseInt(fbPage.id, 10);
                this.props.updateSelectedClient(this.props.params.organizationId, org.name, FacebookAdAccountId, SocialAccountId);

                if (this.props.selectedClient) {
                  this.getReportStuff(this.props.params.organizationId, this.props.params.reportType);
                }

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.selectedClient !== this.props.selectedClient) {
        this.getReportStuff(this.props.params.organizationId, this.props.params.reportType);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearAll();
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0,
          display: 'flex'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Report Builder"
      }), this.props.loadingReport && !this.state.loadedReportOnce ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75,
          flex: '1 0 100%'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))) : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Report Builder",
        style: {
          paddingLeft: 36,
          marginBottom: 16
        },
        secondary: this.props.params.reportId ? 'Edit' : ''
      }), /*#__PURE__*/React.createElement(Settings, {
        getReportStuff: this.getReportStuff,
        orgId: this.props.params.reportId ? this.props.params.orgId : this.props.params.organizationId,
        org: this.props.selectedClient,
        reportId: this.props.params.reportId,
        reportType: this.props.params.reportType ? this.props.params.reportType : this.props.params.reportId ? this.props.selectedReportType : 'socialMediaSummary'
      }), this.props.params.reportId && /*#__PURE__*/React.createElement("div", {
        className: styles.editBar,
        style: {
          backgroundColor: this.props.theme.colors.secondaryColor
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.editBarText
      }, "Editing Report"), /*#__PURE__*/React.createElement("div", {
        className: styles.editBarButtonWrap
      }, this.props.reportsById && this.props.params.reportId && this.props.reportsById[this.props.params.reportId] && this.props.selectedReportType === 'facebookChecklist' && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Refresh Facebook Page Data",
        disabled: this.props.facebookChecklistTemplate.gettingPageFields,
        onClick: function onClick() {
          var SocialAccountId = _this2.props.selectedClient.SocialAccountId;
          var fields = 'page_about_story,price_range,rating_count,about,category,connected_instagram_account,instagram_business_account,instagram_accounts,page_backed_instagram_accounts,settings,cover,emails,founded,hours,messenger_ads_default_icebreakers,link,name,parking,phone,picture,products,ratings,single_line_address,username,unread_message_count,verification_status,website';

          _this2.props.getPageFields(_this2.props.params.orgId, SocialAccountId, fields);
        },
        style: {
          marginRight: 24
        }
      }), this.props.reportsById && this.props.params.reportId && this.props.reportsById[this.props.params.reportId] && this.props.reportsById[this.props.params.reportId].S3File && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Download Report",
        href: this.props.reportsById[this.props.params.reportId].S3File.fullyQualifiedUrl,
        target: "_blank",
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Create New Report",
        onClick: function onClick() {
          _this2.clearAll();

          browserHistory.push("/global/report-builder/org/".concat(_this2.props.params.orgId, "/reportType/socialMediaSummary"));
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, (this.props.params.reportType || this.props.params.reportId) && this.props.selectedClient && /*#__PURE__*/React.createElement(Builder, {
        orgId: this.props.selectedClient.id,
        orgSocialAccountId: this.props.selectedClient.SocialAccountId,
        reportId: this.props.params.reportId,
        reportType: this.props.params.reportType ? this.props.params.reportType : this.props.selectedReportType
      }), (this.props.params.reportType || this.props.params.reportId && this.props.selectedReportType) && this.props.selectedClient && /*#__PURE__*/React.createElement(Preview, {
        reportType: this.props.params.reportType ? this.props.params.reportType : this.props.selectedReportType
      }), !this.props.selectedClient && !this.props.params.reportType && !this.props.params.reportId && /*#__PURE__*/React.createElement(EmptyState, {
        text: "Select A Client Above To Get Started",
        iconName: "fa fa-rocket",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }))));
    }
  }]);

  return ReportBuilder;
}(Component)) || _class);
export { ReportBuilder as default };